export default __webpack_public_path__ + "static/media/brave_zone_background_m2.90735e02.jpg";